import type { TaskActivityResponse, UserActivityResponse } from '@ledokol/contracts'
import { api } from './client'

export async function fetchTaskActivity(taskId: string): Promise<TaskActivityResponse> {
  const r = await api.get<TaskActivityResponse>(`/tasks/${taskId}/activity`)
  return r.data
}

/** #7 слой 3 — лента действий сотрудника. Видимость: self ∨ audit.view (бэк гейтит). */
export async function fetchUserActivity(userId: string): Promise<UserActivityResponse> {
  const r = await api.get<UserActivityResponse>(`/users/${userId}/activity`)
  return r.data
}
